export default "__VITE_ASSET__BsQ5bgY___"